<template>
    <b-card no-body class="mb-4">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Product Stories</h5>
                <b-button
                    size="sm"
                    variant="primary"
                    class="btn-round"
                    @click="showProductStoryDialog = true"
                    v-if="$can('create variant')"
                >
                    <font-awesome-icon :icon="['fas', 'plus']" />
                    Add story
                </b-button>
                <product-story-dialog
                    @saved="reloadProduct()"
                    :base_product_id="product.id"
                    :collection_id="product.collection.id"
                    :id="0"
                    v-model="showProductStoryDialog"
                />
            </div>
        </template>
        <b-card-body>
            <b-table
                class="product-stories-list"
                small
                striped
                hover
                :items="stories"
                :fields="fields"
            >
                <template v-slot:cell(title)="data">
                    <div class="variant-name">
                        {{ data.item.title }}
                    </div>
                </template>
                <template v-slot:cell(text)="data">
                    <div class="variant-name">
                        <span
                            v-html="truncateString(data.item.text, 30)"
                        ></span>
                    </div>
                </template>
                <template v-slot:cell(variant)="data">
                    <div class="variant-name">
                        {{ variants[data.item.variant_id] }}
                    </div>
                </template>
                <template v-slot:cell(controls)="data">
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="editProductStory(data.item)"
                    >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                        {{ $t("edit") }}
                    </b-button>
                </template>
                <template v-slot:cell(delete)="data">
                    <b-button
                        size="sm"
                        variant="danger"
                        class="btn-lte"
                        @click="showDeleteDialog(data.item)"
                    >
                        <font-awesome-icon :icon="['fas', 'trash']" />
                    </b-button>
                </template>
            </b-table>
            <product-story-dialog
                @saved="reloadProduct()"
                v-model="productStoryDialog.show"
                :base_product_id="product.id"
                :collection_id="product.collection.id"
                :id="productStoryDialog.id"
            >
            </product-story-dialog>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ProductStoryDialog from "../EditDialogs/ProductStoryDialog";
import axios from "axios";

export default {
  name: "ProductStory",
  components: { ProductStoryDialog },
  data() {
    return {
      showProductStoryDialog: false,
      deleteDialogVisible: false,
      productStoryDialog: {
        show: false,
        base_product_id: null,
        id: 0
      },
      variants: [],
      stories: [],
      fields: [
        {
          key: "id",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "title",
          sortable: false
        },
        {
          key: "text",
          sortable: false
        },
        {
          key: "variant",
          sortable: false
        },
        {
          key: "controls",
          sortable: false
        },
        {
          key: "delete",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.$root.$on("page-deleted", id => {
      this._removePageFromList(id);
    });
  },
  computed: {
    ...mapState("smartVaultProduct", {
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    })
  },
  mounted() {
    var variants = [];
    this.product.variants.forEach(function(variant) {
      variants[variant.id] = variant.reference;
    });
    this.variants = variants;
    this.fetchProductStories();
  },
  methods: {
    ...mapActions("smartVaultProduct", ["getProduct"]),
    fetchProductStories() {
      axios
        .get(
          `/api/collections/${this.product.collection.id}/products/${
            this.product.id
          }/stories`
        )
        .then(response => {
          this.stories = response.data.data;
        })
        .catch(error => {
          this.$bvToast.toast(
            "Failed to load product stories. Please try again.",
            {
              title: "Error",
              variant: "danger",
              autoHideDelay: 5000,
              solid: true
            }
          );
        });
    },
    addProductStory(newStory) {
      this.stories.unshift(newStory);
    },
    editProductStory(item) {
      this.productStoryDialog = {
        show: true,
        id: item.id || 0
      };
    },
    reloadProduct() {
      this.getProduct(this.product.id);
    },
    truncateString(str, num) {
      if (str.length <= num) {
        return str;
      }
      return str.slice(0, num) + "...";
    },
    showDeleteDialog(item) {
      this.$bvModal
        .msgBoxConfirm("Do you want to delete this product story ?", {
          okVariant: "danger",
          okTitle: this.$t("delete"),
          cancelVariant: this.cancelVariant,
          footerClass: "p-2",
          hideHeaderClose: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deleteProductStory(item);
          }
        });
    },
    deleteProductStory(item) {
      axios
        .delete(
          `/api/collections/${this.product.collection.id}/products/${
            item.product
          }/stories/${item.id}`
        )
        .then(response => {
          if (response.status === 204) {
            this._removePageFromList(item.id);
            return;
          } else {
            this.$bvToast.toast(this.$t("delete_error"), {
              title: this.$t("delete_product_story_error"),
              toaster: "b-toaster-top-right",
              autoHideDelay: 5000,
              appendToast: true,
              solid: true,
              variant: "danger"
            });
          }
        });
    },
    _removePageFromList(pageId) {
      const index = this.stories.findIndex(item => item.id === pageId);
      if (index !== -1) {
        this.stories.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
</style>
